/** @jsx builderX.jsx */

import { builderX, Sprite, Image, MovieClip } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='bigWinParticles'>
        <MovieClip name='diamond'>
            <Image src='diamond_particle_00000' />
            <Image src='diamond_particle_00001' />
            <Image src='diamond_particle_00002' />
            <Image src='diamond_particle_00003' />
            <Image src='diamond_particle_00004' />
            <Image src='diamond_particle_00005' />
            <Image src='diamond_particle_00006' />
            <Image src='diamond_particle_00007' />
            <Image src='diamond_particle_00008' />
            <Image src='diamond_particle_00009' />
            <Image src='diamond_particle_00010' />
            <Image src='diamond_particle_00011' />
            <Image src='diamond_particle_00012' />
            <Image src='diamond_particle_00013' />
            <Image src='diamond_particle_00014' />
            <Image src='diamond_particle_00015' />
            <Image src='diamond_particle_00016' />
            <Image src='diamond_particle_00017' />
            <Image src='diamond_particle_00018' />
            <Image src='diamond_particle_00019' />
        </MovieClip>
        <MovieClip name='yuan'>
            <Image src='yuan_particle_00000' />
            <Image src='yuan_particle_00001' />
            <Image src='yuan_particle_00002' />
            <Image src='yuan_particle_00004' />
            <Image src='yuan_particle_00003' />
            <Image src='yuan_particle_00005' />
            <Image src='yuan_particle_00006' />
            <Image src='yuan_particle_00007' />
            <Image src='yuan_particle_00008' />
            <Image src='yuan_particle_00009' />
            <Image src='yuan_particle_00010' />
            <Image src='yuan_particle_00011' />
            <Image src='yuan_particle_00012' />
            <Image src='yuan_particle_00013' />
            <Image src='yuan_particle_00014' />
            <Image src='yuan_particle_00015' />
            <Image src='yuan_particle_00016' />
            <Image src='yuan_particle_00017' />
            <Image src='yuan_particle_00018' />
            <Image src='yuan_particle_00019' />
        </MovieClip>
        <MovieClip name='coin'>
            <Image src='coin_particle_00000' />
            <Image src='coin_particle_00001' />
            <Image src='coin_particle_00002' />
            <Image src='coin_particle_00003' />
            <Image src='coin_particle_00004' />
            <Image src='coin_particle_00005' />
            <Image src='coin_particle_00006' />
            <Image src='coin_particle_00007' />
            <Image src='coin_particle_00008' />
            <Image src='coin_particle_00009' />
            <Image src='coin_particle_00010' />
            <Image src='coin_particle_00011' />
            <Image src='coin_particle_00012' />
            <Image src='coin_particle_00013' />
            <Image src='coin_particle_00014' />
            <Image src='coin_particle_00015' />
            <Image src='coin_particle_00016' />
            <Image src='coin_particle_00017' />
            <Image src='coin_particle_00018' />
            <Image src='coin_particle_00019' />
        </MovieClip>
    </Sprite>
);
